import React from "react";
import useBreakpoints from "~/hooks/useBreakpoints";

export const NavLink: React.FC<
  React.PropsWithChildren<{
    isActive?: boolean;
    isDropdown?: boolean;
    href?: string;
    target?: "_blank";
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  }>
> = ({ isActive, isDropdown, href, onClick, children, target }) => {
  const { isMobile } = useBreakpoints();

  const styles = `${
    isMobile && isActive ? "font-serif" : ""
  } flex text-[25px] uppercase text-white items-center md:justify-center gap-2 md:text-sm md:normal-case md:text-blue400 md:visited:text-blue450 md:visited:text- cursor-pointer md:fill-black lg:px-[0.09rem] ${isDropdown ? `nav-link-with-menu fill-white md:[&_svg]:mt-[0.125rem] md:px-1 md:gap-2 mmd:gap-2 md:after:content-[''] md:after:hidden md:after:absolute md:after:left-[-0.25rem] mmd:after:left-[-0.3125rem] md:after:bg-blue md:after:w-[calc(100%-0.375rem)] mmd:after:w-[calc(100%-0.4375rem)] xmd:after:w-[calc(100%-0.3125rem)] lg:after:w-[calc(100%-0.4375rem)] md:after:h-full md:after:z-[-10]` : ""}`;

  if (isMobile && isDropdown && onClick) {
    return (
      <button
        title="Toggle Menu"
        onClick={onClick}
        className={styles}
      >
        {children}
      </button>
    );
  }

  return (
    <>
      <a
        href={href}
        className={styles}
        onClick={onClick}
        target={target}
      >
        {children}
      </a>
    </>
  );
};

const NavItem: React.FC<
  React.PropsWithChildren<{
    testId?: string;
    isActive?: boolean;
    className?: string;
  }>
> = ({ children, isActive, testId, className }) => (
  <li
    data-testid={testId}
    aria-expanded={isActive}
    className={`${
      isActive ? "mb-2 block h-full" : "hidden"
    } group/nav-item md:before-content-[''] h-10 last:mb-[100px] first-of-type:mt-[25px] md:relative md:flex md:h-auto md:pb-2 md:before:absolute md:before:top-[100%] md:before:h-2 md:before:w-full md:after:mx-2 md:after:mt-[0.25rem] md:after:h-[0.875rem] md:after:border-r-[1px] md:after:text-black md:last:mb-2 md:last:before:content-none md:last:after:content-none md:first-of-type:mt-0 lg:after:mx-2 md:[&:hover>.nav-link-with-menu]:fill-white md:[&:hover>.nav-link-with-menu]:text-white md:[&:hover>.nav-link-with-menu]:after:block ${className}`}
  >
    {children}
  </li>
);

export default NavItem;
